import { useShadowRoot } from "@/helpers/ShadowRootContext.ts";
import { ReactNode, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

const ReactPortal = ({
  children,
  wrapperId = "react-portal-wrapper",
}: {
  children: ReactNode;
  wrapperId: string;
}) => {
  const { containerEl } = useShadowRoot();
  const [wrapperElement, setWrapperElement] = useState<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    let existing = containerEl.querySelector<HTMLDivElement>(`#${wrapperId}`);
    if (!existing) {
      existing = document.createElement("div");
      existing.setAttribute("id", wrapperId);
      containerEl.appendChild(existing);
    }
    setWrapperElement(existing);

    return () => {
      existing?.remove();
    };
  }, [wrapperId, containerEl]);

  return wrapperElement ? createPortal(children, wrapperElement) : null;
};

export default ReactPortal;
